export default {
  new: 1,
  coordinated: 3,
  denied: 4,
  processed: 5,
  approved: 6,
  recoordinated: 7,
  rempro: 8,
  inactive: 9,
  provisionalApproved: 10,
  pendingSignature: 15,
};
